import React from 'react';

const partners = [
    {
        name: 'REDAC7D',
        logo: '/partners/redac7d.png',
    },
    {
        name: 'RekaProteksi.id',
        logo: '/partners/rekaproteksi.png',
    },
    {
        name: 'FamilyMart',
        logo: '/partners/familymart.png',
    },
];

const Partners = () => {
    return (
        <section className="bg-[#0f0f0f] text-white px-6 md:px-16 py-20">
            <div className="text-center mb-12" data-aos="fade-up" data-aos-duration="800">
                <h2 className="text-3xl font-bold mb-2">
                    <span className="text-white">Community &</span>{' '}
                    <span className="text-red-500">Partners</span>
                </h2>
                <p className="text-gray-400 max-w-2xl mx-auto">
                    Trusted by organizations across Indonesia. Together, we build a stronger cybersecurity ecosystem.
                </p>
            </div>

            <div
                className="flex flex-wrap justify-center items-center gap-12 md:gap-16"
                data-aos="fade-up"
                data-aos-delay="200"
                data-aos-duration="800"
            >
                {partners.map((partner, index) => (
                    <div
                        key={index}
                        className="flex items-center justify-center bg-[#1a1a1a] rounded-lg border border-gray-700 hover:border-red-500 transition p-6 w-52 h-32"
                    >
                        <img
                            src={partner.logo}
                            alt={partner.name}
                            className="max-h-20 max-w-full object-contain"
                        />
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Partners;
